import React, { useEffect, useState, useCallback } from 'react';
import _ from 'lodash';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLSignNowService, MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLEndorsementFlowUtil } from 'ml-portals-util-js';
import { EndorsementService } from 'gw-capability-policychange';
import { PolicyChange } from 'gw-capability-policychange-common-react';

import appConfig from 'app-config';
import metadata from './PolicyChangeESignaturePage.metadata.json5';
import messages from './PolicyChangeESignaturePage.messages'
import popupEntryMetadata from './PolicyChangeESignaturePopupEntry.metadata.json5'



const {
    MLSignNowResponsePath
} = appConfig;

const PolicyChangeESignaturePage=(props)=>{
    const modalApi = useModal();
    const{
        wizardData,
        goNext,
        // isSkipping,
        history,
        currentStepIndex,
        steps,
        changeNextSteps,
    }=props

    const translator = useTranslator()
    const { authHeader } = useAuthentication();
    const submissionVM  = wizardData.submissionVM;
    const ModalService = MLModalService();


    const [showSignNow, setShowSignNow] = useState(false);
    const [signNowURL, setSignNowURL] = useState(null);
    const [redirectURLUnencoded, setRedirectURLUnencoded] = useState(null);

    const forms = _.get(submissionVM, 'baseData.forms_ML.value', []);
    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const hasFormToSign= forms.some((form)=> form.esigned_ML);

    const onFinishLater = () => {
        MLEndorsementFlowUtil.addAndNavigateToSelectedStep("endorsementAdditionalChanges", steps, currentStepIndex, changeNextSteps, goNext, productCode) 
    };

    const continueToIFrame = () => {
        setShowSignNow(true);
    };

    const requireMultipleSigners = useCallback(() => {
        const requiredMultipleSignatures= _.get(submissionVM,'baseData.requireMultipleSigners_ML.value')
        return requiredMultipleSignatures;
    },[submissionVM]);

    let showExitPopup;

    const showEntryPopup = useCallback(() => {
        const overrides = {
            additionalRequiredSignatures: {
                visible: requireMultipleSigners()
            },
            continueSignAndFinishPolicy: {
                content: <FormattedMessage
                    {...messages.clickContinue}
                    values={{
                        continue: <strong>{translator(messages.continue).toUpperCase()}</strong>,
                    }}
                />
            }
        };

        const componentProps = {
            title: translator(messages.entryPopupTitle),
            uiProps: popupEntryMetadata.pageContent,
            overrideProps: overrides,
            actionBtnLabel: messages.continue,
            onSaveAction: () => {
                continueToIFrame();
                return true;
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        // eslint-disable-next-line no-use-before-define
        ).catch(showExitPopup);
    }, [requireMultipleSigners, showExitPopup, translator]);

    showExitPopup = useCallback(() => {
        const componentProps = {
            title: translator(messages.exitPopupTitle),
            subtitle: translator(messages.exitPopupSubtitle),
            uiProps: {},
            actionBtnLabel: messages.finishLater,
            cancelBtnLabel: messages.cancel,
            onSaveAction: () => {
                onFinishLater();
                return true;
            }
        };
        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).catch(showEntryPopup);
    }, [showEntryPopup, translator]);


    const onNext = useCallback(() => {
        const bindEndorsementPromise = EndorsementService.bindEndorsement(submissionVM.jobID.value, submissionVM.paymentDetails_ML.value, authHeader)
        ModalService.showProgressDialog(platformMessages.bindingPolicyChange, bindEndorsementPromise);
        bindEndorsementPromise.then(({ policyChange, ...rest }) => {
            MLNavigationStepsTrackingService.stepChange(null, 'endorsementESignature');
            MLTagManagerService.sendFormStepPolicyChangeStep();
            submissionVM.value = new PolicyChange(policyChange, rest);
            goNext();
        })
    }, [goNext, submissionVM]);

    const onLoadSignNowFrame = useCallback(() => {
        const signNowRequest = {
            quoteID: submissionVM.value.jobID,
            sessionUUID: submissionVM.value.sessionUUID
        };

        let url = "";
        try {
            const frame = document.getElementById('signNowFrame');
            url = frame.contentWindow.location.href;
        } catch (error) {
            // do nothing - this is needed to prevent DOMException error message when iframe first loads
        }

        if (url === redirectURLUnencoded) {
            MLSignNowService.markEndorsementFormsAsSigned(signNowRequest,authHeader).then(() => {
                // MLBundleService.setJobPostQuoteComplete(submissionVM.quoteID.value);
                onNext()
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onNext, redirectURLUnencoded, submissionVM]);

    useEffect(()=>{
        if(!hasFormToSign){
            onNext();
        }else{
            const signNowRequest = {
                quoteID: submissionVM.value.jobID,
                sessionUUID: submissionVM.value.sessionUUID
            };
            MLSignNowService.getEndorsementSigningURL(signNowRequest,authHeader).then((result) => {
                const redirectURL = `${window.location.protocol}//${window.location.host}${MLSignNowResponsePath}`;
                setRedirectURLUnencoded(`${window.location.protocol}//${window.location.host}${MLSignNowResponsePath}`);
                const uri = encodeURIComponent(redirectURL);
                setSignNowURL(`${result}&redirect_uri=${uri}`);
            });
            showEntryPopup();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const getClickToDiscardContent=()=>{
        return <FormattedMessage
            {...messages.discardChangesTemplate}
            values={{
                strongName1: <strong>{translator(messages.discardAllChanges).toUpperCase()}</strong>,
                strongName2:<strong>{translator(messages.policies)}</strong>
            }}
        />
    }
    const withdraw=()=>{
        MLTagManagerService.sendLinkClickEvent('Discard All Changes');
        const withdrawPromise = EndorsementService.withdrawEndorsement([submissionVM.value.jobID], authHeader);
        ModalService.showProgressDialog(messages.withdrawingPolicyChange, withdrawPromise);
        history.push(`/policies/${_.get(submissionVM, 'policyNumber.value')}/summary`);
    }

    const overrides = {
        loading: {
            visible: !showSignNow || signNowURL === null
        },
        signNowFrame: {
            visible: showSignNow && signNowURL !== null,
            src: signNowURL,
            height: '1300px',
            onLoad: onLoadSignNowFrame
        },
        clickToDiscard:{
            content: getClickToDiscardContent()
        },
        discardChangesButton:{
            onClick:withdraw
        },
        discardChangesContainer: {
            visible: hasFormToSign
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrides}
            />
        </WizardPage>
    );
}
PolicyChangeESignaturePage.propTypes = wizardProps;
export default withRouter(PolicyChangeESignaturePage)